import { useLocation, useNavigate } from "react-router-dom";

import QuizeCheck from "./quizeCheck";
import ChatBoxType2 from "../chat/chatType2";
import Header from "../header/header";
import Wrong from "../wrong/wrong";
import Hint from "../hint/hint";
import { useState, useEffect, useRef } from "react";

import "./quiz.css";

export default function Quize({
  answerData,
  DateVal,
  titImgclassName,
  hintWhetherIs,
  hintContent,
}) {
  //const navigate = useNavigate();
  const [showWrong, setShowWrong] = useState(false);
  const [hintWhether, setHintWhether] = useState(false);
  const [showHint, setShowHint] = useState(false);

  //state
  const { state } = useLocation();
  const navigate = useNavigate();

  const chatRef = useRef(null);

  if (state) {
    const {
      answerDataState,
      DateValState,
      titImgclassNameState,
      hintWhetherIsState,
      hintContentState,
    } = state;
    answerData = answerDataState;
    DateVal = DateValState;
    titImgclassName = titImgclassNameState;
    hintWhetherIs = hintWhetherIsState;
    hintContent = hintContentState;
  }

  useEffect(() => {
    setHintWhether(hintWhetherIs);
  }, [hintWhetherIs]);
  return (
    <div id="content">
      <Header initialTime={1800} missionCount={3} missionTotal={8} />
      <div className="box box_con con_box1 con_pd5 con_box_c ans0001">
        <div className="mission_tit messageTit01">
          {hintWhether && (
            <a className="hint_d" onClick={() => setShowHint(true)}>
              <span className="hint_in hint_icon mr4"></span>
              <span className="hint_in hint_txt">힌트보기</span>
            </a>
          )}
        </div>

        <ChatBoxType2
          DateVal={DateVal}
          titImgclassName={titImgclassName}
          timerMode="run"
          ref={chatRef}
        />

        <QuizeCheck
          onWrong={() => setShowWrong(true)}
          answerData={answerData}
        />

        {showWrong && <Wrong onClose={() => setShowWrong(false)} />}
        {showHint && (
          <Hint hintContent={hintContent} onClose={() => setShowHint(false)} />
        )}
      </div>
    </div>
  );
}
